import React, { useState, useEffect } from "react";

const TIPS = [
    "Did you know? The first computer bug was an actual moth trapped in a relay.",
    "Study Tip: The Pomodoro technique suggests 25 minutes of focus followed by a 5-minute break.",
    "Did you know? Python was named after Monty Python's Flying Circus, not the snake.",
    "Study Tip: Teaching someone else is one of the best ways to retain new information.",
    "Did you know? The first 1GB hard drive (1980) weighed over 500 pounds and cost $40,000.",
    "Study Tip: Active recall (testing yourself) is more effective than re-reading notes.",
    "Did you know? There are over 700 programming languages in use today.",
    "Fun Fact: 90% of the world's currency exists only on computers.",
];

const STAGES = [
    { threshold: 10, text: "Initializing request..." },
    { threshold: 30, text: "Downloading content..." },
    { threshold: 60, text: "Transcribing audio..." },
    { threshold: 85, text: "Analyzing text & generating insights..." },
    { threshold: 95, text: "Finalizing results..." },
];

const LoadingComponent = () => {
    const [progress, setProgress] = useState(0);
    const [elapsed, setElapsed] = useState(0);
    const [tipIndex, setTipIndex] = useState(0);

    useEffect(() => {
        const startTime = Date.now();

        // Progress Timer
        const progressInterval = setInterval(() => {
            setElapsed((Date.now() - startTime) / 1000);

            setProgress((prev) => {
                if (prev >= 99) return 99;
                const remaining = 99 - prev;
                const increment = remaining * 0.05;
                // Ensure a minimum movement so it feels "alive", but reduce it as we get closer to 99
                const movement = Math.max(0.01, increment);
                return Math.min(prev + (movement * 0.2), 99);
            });
        }, 200);

        // Tip Rotation Timer (every 5 seconds)
        const tipInterval = setInterval(() => {
            setTipIndex((prev) => (prev + 1) % TIPS.length);
        }, 5000);

        return () => {
            clearInterval(progressInterval);
            clearInterval(tipInterval);
        };
    }, []);

    // Determine current stage text based on progress
    const currentStage = STAGES.findLast(s => progress >= s.threshold) || STAGES[0];

    return (
        <div className="glass-container" style={{
            marginTop: "20px",
            textAlign: "center",
            position: "relative",
            overflow: "hidden",
            padding: "40px",
            minHeight: "300px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.37)"
        }}>
            <h2 style={{
                margin: "0 0 15px 0",
                color: "var(--primary-color)",
                textShadow: "0 0 10px rgba(187, 134, 252, 0.5)",
                fontSize: "1.8em"
            }}>Cooking Up Content...</h2>

            <p style={{
                fontSize: "1.2em",
                fontWeight: "500",
                opacity: 0.9,
                marginBottom: "20px",
                minHeight: "1.5em",
                color: "#fff"
            }}>
                {currentStage.text}
            </p>

            {/* Progress Bar Container */}
            <div style={{
                width: "100%",
                maxWidth: "500px",
                height: "16px",
                background: "rgba(255,255,255,0.05)",
                borderRadius: "10px",
                marginBottom: "25px",
                overflow: "hidden",
                position: "relative",
                border: "1px solid rgba(255,255,255,0.1)"
            }}>
                {/* Progress Bar Fill with Pulse Effect */}
                <div style={{
                    height: "100%",
                    width: `${progress}%`,
                    background: "linear-gradient(90deg, var(--primary-color), var(--secondary-color))",
                    borderRadius: "10px",
                    transition: "width 0.2s linear",
                    boxShadow: "0 0 15px rgba(3, 218, 198, 0.6)",
                    position: "relative"
                }}>
                    <div style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent)",
                        animation: "shimmer 1.5s infinite",
                    }} />
                </div>
            </div>

            {/* Centered Percentage and Time */}
            <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "5px",
                marginBottom: "30px"
            }}>
                <span style={{
                    fontSize: "2.5em",
                    fontWeight: "bold",
                    color: "var(--secondary-color)",
                    textShadow: "0 0 20px rgba(3, 218, 198, 0.3)"
                }}>
                    {Math.round(progress)}%
                </span>
                <span style={{
                    fontSize: "0.9em",
                    opacity: 0.6,
                    letterSpacing: "1px"
                }}>
                    {Math.round(elapsed)}s ELAPSED
                </span>
            </div>

            <div style={{
                background: "rgba(255,255,255,0.03)",
                padding: "20px",
                borderRadius: "12px",
                width: "90%",
                maxWidth: "450px",
                borderLeft: "4px solid var(--secondary-color)",
                textAlign: "left"
            }}>
                <p style={{
                    fontStyle: "italic",
                    margin: 0,
                    fontSize: "1em",
                    lineHeight: "1.5",
                    color: "#ddd"
                }}>
                    {TIPS[tipIndex]}
                </p>
            </div>

            <style>{`
                @keyframes shimmer {
                    0% { transform: translateX(-100%); }
                    100% { transform: translateX(100%); }
                }
            `}</style>
        </div>
    );
};

export default LoadingComponent;
